const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer>
        <h4>Copyrights &copy; { currentYear } DazWay. All Rights Reserved.</h4>
      </footer>
    </>
  );
}
export default Footer;
